"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AVAILABLE_STATUS = exports.USER_TYPE = exports.USER_STATUS = void 0;
var USER_STATUS;
(function (USER_STATUS) {
    USER_STATUS["ACTIVE"] = "ACTIVE";
    USER_STATUS["DELETED"] = "DELETED";
    USER_STATUS["BLOCKED"] = "BLOCKED";
})(USER_STATUS || (exports.USER_STATUS = USER_STATUS = {}));
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["USER"] = "USER";
    USER_TYPE["APP"] = "APP";
    USER_TYPE["PATIENT"] = "PATIENT";
    USER_TYPE["STAFF"] = "STAFF";
    USER_TYPE["ADMIN"] = "ADMIN";
    USER_TYPE["PHYSICIAN"] = "PHYSICIAN";
})(USER_TYPE || (exports.USER_TYPE = USER_TYPE = {}));
var USER_AVAILABLE_STATUS;
(function (USER_AVAILABLE_STATUS) {
    USER_AVAILABLE_STATUS["AVAILABLE"] = "AVAILABLE";
    USER_AVAILABLE_STATUS["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(USER_AVAILABLE_STATUS || (exports.USER_AVAILABLE_STATUS = USER_AVAILABLE_STATUS = {}));
